import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from 'axios';
import { COMMON_API } from '../../CommonAPI';

const AddPortfolio = () => {
    const [category, setCategory] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = sessionStorage.getItem("authToken");
            await axios.post(`${COMMON_API}/api/portfolio/create-portfolio`, { category }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Portfolio added successfully!");
            navigate("/portfolio");
        } catch (error) {
            toast.error("Error adding portfolio");
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <h2 className="text-3xl font-semibold mb-6 text-gray-800">Add Portfolio</h2>
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow max-w-lg">
                <div className="mb-4">
                    <label className="block text-gray-700 font-medium mb-2">Category</label>
                    <input
                        type="text"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                    Add Portfolio
                </button>
            </form>
        </div>
    );
};

export default AddPortfolio;
